import { createRoute } from '@tanstack/react-router';
import { TourBuilderProvider } from '@/features/dashboard/tourConfig/contexts/TourBuilderContext.tsx';
import EditTourBasicsPage from '@/features/dashboard/tourConfig/pages/EditTourBasicsPage.tsx';
import TourConfigCostsPage from '@/features/dashboard/tourConfig/pages/TourConfigCostsPage.tsx';
import CreateTourBasicsPage from '@/features/dashboard/tourConfig/pages/CreateTourBasicsPage.tsx';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';

export const tourNewConfigRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/tours/new/config',
  component: TourBuilderProvider,
});

export const tourNewConfigBasicRoute = createRoute({
  getParentRoute: () => tourNewConfigRoute,
  path: 'basics',
  component: CreateTourBasicsPage,
});

export const tourConfigRoute = createRoute({
  getParentRoute: () => appRoute,
  path: 'tours/$tourId/config',
  component: TourBuilderProvider,
});

export const editTourBasicsRoute = createRoute({
  getParentRoute: () => tourConfigRoute,
  path: 'basics',
  component: EditTourBasicsPage,
});

export const tourConfigCostsRoute = createRoute({
  getParentRoute: () => tourConfigRoute,
  path: 'costs',
  component: TourConfigCostsPage,
});
